function shopList() {
  const shops = [
    {
      latitude: 28.0575662,
      longitud: -15.6087038,
      title: "Tienda agricol",
      descripcion: "Easily customizable",
    },
    {
      latitude: 28.0575662,
      longitud: -15.6097040,
      title: "A pretty CSS3 popup.",
      descripcion: "Easily customizable",
    },
  ];

  return shops;
}
export default shopList;